/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class ApiClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    // this.baseUrl = "https://tooling-dev.polarisportal.com";
    //  this.baseUrl = "https://localhost:7176";
  }

  getRequestor_Api(
    body: approverManagers | undefined
  ): Promise<approverManagers> {
    let url_ = this.baseUrl + "/AzureAdAuth/CurrentUser";

    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      credentials: "include",
    };
    return this.http.fetch(url_, options_).then((_response: any) => {
      return this.process_GetRequestor_Api(_response);
    });
  }
  protected process_GetRequestor_Api(
    response: Response
  ): Promise<approverManagers> {
    const status = response.status;
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = approverManagers.fromJS(resultData200);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        return throwException("Unauthorized", status, _responseText, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          ""
        );
      });
    }
    return Promise.resolve<approverManagers>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */

  getApprovers_Api(body: approverManagers | any): Promise<approverManagers> {
    let url_ = this.baseUrl + `${"/api/Approvers?keyword=" + body}`;

    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      credentials: "include",
    };
    return this.http.fetch(url_, options_).then((_response: any) => {
      return this.process_GetApprovers_Api(_response);
    });
  }
  protected process_GetApprovers_Api(
    response: Response
  ): Promise<approverManagers> {
    const status = response.status;
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(approverManagers.fromJS(item));
        }
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        return throwException("Unauthorized", status, _responseText, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          ""
        );
      });
    }
    return Promise.resolve<approverManagers>(<any>null);
  }

  getDisposalRequestsFilters_Get_API(
    body: disposalRequestsFilters | undefined
  ): Promise<disposalRequestsFilters> {
    let url_ =
      this.baseUrl + "/api/Tools?ApiType=DisposalRequestsFilters_Get_API";

    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      credentials: "include",
    };
    return this.http.fetch(url_, options_).then((_response: any) => {
      return this.process_DisposalRequestsFilters_Get_API(_response);
    });
  }
  protected process_DisposalRequestsFilters_Get_API(
    response: Response
  ): Promise<disposalRequestsFilters> {
    const status = response.status;
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = disposalRequestsFilters.fromJS(resultData200);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        return throwException("Unauthorized", status, _responseText, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          ""
        );
      });
    }
    return Promise.resolve<disposalRequestsFilters>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */

  /**
   * @param body (optional)
   * @return Success
   */

  getNewRequest_productLines(
    body: productLineRequest | undefined
  ): Promise<productLineResponse> {
    let url_ =
      this.baseUrl + "/api/Tools?ApiType=Projects_ProductLines_Get_API";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      credentials: "include",
    };
    return this.http.fetch(url_, options_).then((_response: any) => {
      return this.processNewRequest_productLines_GetDetails(_response);
    });
  }
  protected processNewRequest_productLines_GetDetails(
    response: Response
  ): Promise<productLineResponse> {
    const status = response.status;

    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = productLineResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        return throwException("Unauthorized", status, _responseText, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          ""
        );
      });
    }
    return Promise.resolve<productLineResponse>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */

  getNewRequest_toolTypes(
    body: toolTypeRequest | undefined
  ): Promise<toolTypeResponse> {
    let url_ = this.baseUrl + "/api/Tools?ApiType=Tools_ToolTypes_Get_API";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      credentials: "include",
    };
    return this.http.fetch(url_, options_).then((_response: any) => {
      return this.processNewRequest_toolTypes_GetDetails(_response);
    });
  }

  protected processNewRequest_toolTypes_GetDetails(
    response: Response
  ): Promise<toolTypeResponse> {
    const status = response.status;

    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = toolTypeResponse.fromJS(resultData200);

        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        return throwException("Unauthorized", status, _responseText, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          ""
        );
      });
    }
    return Promise.resolve<toolTypeResponse>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */

  getNewRequest_states(body: stateRequest | undefined): Promise<any> {
    const countryCode = body;
    let url_ =
      this.baseUrl +
      `${"/api/Tools?ApiType=Tools_States_Get_API&CountryCode=" + countryCode}`;
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      credentials: "include",
    };
    return this.http.fetch(url_, options_).then((_response: any) => {
      return this.processNewRequest_states_GetDetails(_response);
    });
  }

  protected processNewRequest_states_GetDetails(
    response: Response
  ): Promise<stateResponse> {
    const status = response.status;

    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = stateResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        return throwException("Unauthorized", status, _responseText, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          ""
        );
      });
    }
    return Promise.resolve<stateResponse>(<any>null);
  }
  /**
   * @param body (optional)
   * @return Success
   */

  getNewRequest_projectNumber(
    body: projectNumberRequest | undefined
  ): Promise<projectNumberResponse> {
    let url_ =
      this.baseUrl + "/api/Tools?ApiType=Projects_ProjectNumbers_Get_API";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      credentials: "include",
    };
    return this.http.fetch(url_, options_).then((_response: any) => {
      return this.processNewRequest_projectNumber_GetDetails(_response);
    });
  }

  protected processNewRequest_projectNumber_GetDetails(
    response: Response
  ): Promise<projectNumberResponse> {
    const status = response.status;

    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = projectNumberResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        return throwException("Unauthorized", status, _responseText, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          ""
        );
      });
    }
    return Promise.resolve<projectNumberResponse>(<any>null);
  }
  /**
   * @param body (optional)
   * @return Success
   */

  getNewRequest_suppliers(
    body: supplierRequest | any
  ): Promise<supplierResponse> {
    let url_ =
      this.baseUrl +
      `${
        "/api/Tools?ApiType=Tools_Suppliers_Get_API&SupplierNumber=&SupplierName=" +
        body
      }`;

    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      credentials: "include",
    };
    return this.http.fetch(url_, options_).then((_response: any) => {
      return this.processNewRequest_suppliers_GetDetails(_response);
    });
  }

  protected processNewRequest_suppliers_GetDetails(
    response: Response
  ): Promise<supplierResponse> {
    const status = response.status;

    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = supplierResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        return throwException("Unauthorized", status, _responseText, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          ""
        );
      });
    }
    return Promise.resolve<supplierResponse>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  getNewRequest_suppliersNumber(
    body: supplierRequest | any
  ): Promise<supplierResponse> {
    let url_ =
      this.baseUrl +
      "/api/Tools?ApiType=Tools_Suppliers_Get_API&SupplierNumber=" +
      body +
      "&SupplierName=";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      credentials: "include",
    };
    return this.http.fetch(url_, options_).then((_response: any) => {
      return this.processNewRequest_suppliersNumber_GetDetails(_response);
    });
  }

  protected processNewRequest_suppliersNumber_GetDetails(
    response: Response
  ): Promise<supplierResponse> {
    const status = response.status;

    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = supplierResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        return throwException("Unauthorized", status, _responseText, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          ""
        );
      });
    }
    return Promise.resolve<supplierResponse>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  getNewRequest_countries(
    body: countryRequest | undefined
  ): Promise<countryResponse> {
    let url_ = this.baseUrl + "/api/Tools?ApiType=Tools_Countries_Get_API";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      credentials: "include",
    };
    return this.http.fetch(url_, options_).then((_response: any) => {
      return this.processNewRequest_countries_GetDetails(_response);
    });
  }

  protected processNewRequest_countries_GetDetails(
    response: Response
  ): Promise<countryResponse> {
    const status = response.status;

    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = countryResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        return throwException("Unauthorized", status, _responseText, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          ""
        );
      });
    }
    return Promise.resolve<countryResponse>(<any>null);
  }

  getNewRequest_item(body: itemRequest | any): Promise<itemResponse> {
    let url_ =
      this.baseUrl +
      `${
        "/api/Tools?ApiType=Items_Get_API&SupplierNumber=" +
        (body.supplierNumber ?? "") +
        "&ItemNumber=" +
        body.itemNumber
      }`;
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      credentials: "include",
    };
    return this.http.fetch(url_, options_).then((_response: any) => {
      return this.processNewRequest_item_GetDetails(_response);
    });
  }

  protected processNewRequest_item_GetDetails(
    response: Response
  ): Promise<itemResponse> {
    const status = response.status;

    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = itemResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        return throwException("Unauthorized", status, _responseText, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          ""
        );
      });
    }
    return Promise.resolve<itemResponse>(<any>null);
  }

  //....

  getNewRequest_itemForSupplier(
    body: itemRequest | any
  ): Promise<itemResponse> {
    let url_ =
      this.baseUrl +
      `${
        "/api/Tools?ApiType=Items_Get_API&SupplierNumber=" +
        body +
        "&ItemNumber="
      }`;
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      credentials: "include",
    };
    return this.http.fetch(url_, options_).then((_response: any) => {
      return this.processNewRequest_itemForSupplier_GetDetails(_response);
    });
  }

  protected processNewRequest_itemForSupplier_GetDetails(
    response: Response
  ): Promise<itemResponse> {
    const status = response.status;

    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = itemResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        return throwException("Unauthorized", status, _responseText, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          ""
        );
      });
    }
    return Promise.resolve<itemResponse>(<any>null);
  }

  //....

  getDisposalRequest(
    body: ToolDisposalFilterset
  ): Promise<tooldisposalResponse> {
    let abc = body;
    let AssignedTo = body.AssignedTo;
    let url_ =
      this.baseUrl +
      `${
        "/api/Tools?ApiType=DisposalRequests_Get_API&DisposalStatusId=" +
        body.DisposalStatusId +
        "&SearchTerm=" +
        body.SearchTerm +
        "&RequestedBy=" +
        body.RequestedBy +
        "&LastModifiedDateMin=" +
        body.LastModifiedDateMin +
        "&LastModifiedDateMax=" +
        body.LastModifiedDateMax +
        "&CompletedDateMin=" +
        body.CompletedDateMin +
        "&CompletedDateMax=" +
        body.CompletedDateMax +
        "&AssignedTo=" +
        body.AssignedTo +
        "&PageNumber=" +
        body.PageNumber +
        "&PageSize=" +
        body.PageSize +
        "&SortColumn=" +
        body.SortColumn +
        "&SortDirection=" +
        body.SortDirection +
        "&CurrentUserEmail=" +
        body.CurrentUserEmail +
        "&RequestId=" +
        body.RequestId
      }`;

    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      credentials: "include",
    };
    return this.http.fetch(url_, options_).then((_response: any) => {
      return this.processDisposalRequest_GetDetails(_response);
    });
  }

  protected processDisposalRequest_GetDetails(
    response: Response
  ): Promise<tooldisposalResponse> {
    const status = response.status;

    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = tooldisposalResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        return throwException("Unauthorized", status, _responseText, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          ""
        );
      });
    }
    return Promise.resolve<tooldisposalResponse>(<any>null);
  }

  getTool(body: toolRequest | any): Promise<toolResponse> {
    let url_ =
      this.baseUrl + `${"/api/Tools?ApiType=Tools_Get_API&ToolNumber=" + body}`;
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      credentials: "include",
    };
    return this.http.fetch(url_, options_).then((_response: any) => {
      return this.processTool_GetDetails(_response);
    });
  }

  protected processTool_GetDetails(response: Response): Promise<toolResponse> {
    const status = response.status;

    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = toolResponse.fromJS(resultData200);

        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        return throwException("Unauthorized", status, _responseText, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          ""
        );
      });
    }
    return Promise.resolve<toolResponse>(<any>null);
  }

  disposalRequests_UpdateRecord(
    body: toolDisposalRequest | undefined
  ): Promise<tooldisposalResponse> {
    let sourcingId = window.location.origin.match("dev")
      ? "DEVTOOLSAPPROVALDB"
      : window.location.origin.match("stg")
      ? "STGTOOLSAPPROVALDB"
      : "PRDTOOLSAPPROVALDB";
    let bodyData = {
      DisposalRequest: [
        {
          ...body,
          sourceSystemId: sourcingId,
          lastUpdatedDateTime: new Date(),
        },
      ],
    };

    let url_ = this.baseUrl + "/api/Tools?ApiType=DisposalRequests_Post_API";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(bodyData);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    };

    return this.http.fetch(url_, options_).then((_response: any) => {
      return this.processdisposalRequest_UpdateRecord(_response);
    });
  }
  protected processdisposalRequest_UpdateRecord(
    response: Response
  ): Promise<tooldisposalResponse> {
    const status = response.status;

    if (status === 201) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = tooldisposalResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        return throwException("Unauthorized", status, _responseText, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          ""
        );
      });
    }
    return Promise.resolve<tooldisposalResponse>(<any>null);
  }

  disposalRequests_Attachments_Upload_toRequestId(
    body: attachments
  ): Promise<attachments> {
    let formData = new FormData();
    formData.append("file", body.file as File);
    let url_ =
      this.baseUrl +
      `/api/Tools/UploadFile/${body.originalRequestId}/attachments`;
    url_ = url_.replace(/[?&]$/, "");
    let options_ = <RequestInit>{
      body: formData,
      method: "POST",
      credentials: "include",
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processdisposalRequest_Attachments_Upload(_response);
    });
  }

  protected processdisposalRequest_Attachments_Upload(
    response: Response
  ): Promise<attachments> {
    const status = response.status;

    if (status === 201) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText;
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        return throwException("Unauthorized", status, _responseText, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          ""
        );
      });
    }
    return Promise.resolve<attachments>(<any>null);
  }

  disposalRequests_Attachments_Upload_TempFolder(
    body: attachments
  ): Promise<attachments> {
    let formData = new FormData();
    // formData.append('key', 'file');
    formData.append("file", body.file as File);
    let url_ =
      this.baseUrl +
      `/api/Tools/UploadFile/temprequestid-${body.tempRequestId}/temp`;
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      body: formData,
      method: "POST",
      credentials: "include",
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processdisposalRequest_Attachments_TempFolder(_response);
    });
  }

  protected processdisposalRequest_Attachments_TempFolder(
    response: Response
  ): Promise<attachments> {
    const status = response.status;

    if (status === 201) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText;
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        return throwException("Unauthorized", status, _responseText, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          ""
        );
      });
    }
    return Promise.resolve<attachments>(<any>null);
  }

  disposalRequests_Attachments_Upload_MoveFile(
    body: attachments
  ): Promise<attachments> {
    let url_ = this.baseUrl + "/api/Tools/MoveFile";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processdisposalRequest_Attachments_MoveFile(_response);
    });
  }

  protected processdisposalRequest_Attachments_MoveFile(
    response: Response
  ): Promise<any> {
    const status = response.status;
    if (status === 204 || status === 200) {
      let response: any = status.toString();
      return response;
    } else {
      let response: any = status.toString();
      return response;
    }
  }

  disposalRequests_Attachments_DeleteFile(
    body: attachments
  ): Promise<attachments> {
    let url_ = this.baseUrl + "/api/Tools/MoveFile";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processdisposalRequest_Attachments_DeleteFile(_response);
    });
  }

  protected processdisposalRequest_Attachments_DeleteFile(
    response: Response
  ): Promise<any> {
    const status = response.status;
    if (status === 204 || status === 200) {
      let response: any = status.toString();
      return response;
    } else {
      let response: any = status.toString();
      return response;
    }
  }

  disposalRequests_Attachments_Download(
    body: attachments
  ): Promise<attachments> {
    let url_ =
      this.baseUrl +
      `/api/Tools/DownloadFile?tempRequestId=${body.tempRequestId}&originalRequestId=${body.originalRequestId}&fileName=${body.fileName}`;
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      method: "GET",
      credentials: "include",
    };
    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processdisposalRequest_Attachments_Download(_response, url_);
    });
  }

  protected processdisposalRequest_Attachments_Download(
    response: Response,
    url_: string
  ): Promise<any> {
    const status = response.status;
    if (status === 204 || status === 200) {
      let response: any = url_;
      return response;
    } else {
      let response: any = "";
      return response;
    }
  }
  approve_put(body: approval | undefined): Promise<void> {
    let url_ =
      this.baseUrl + "/api/Tools?ApiType=DisposalRequests_Approval_Put_API";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.process_approve_put(_response);
    });
  }

  protected process_approve_put(response: Response): Promise<void> {
    const status = response.status;

    if (status === 201) {
      let response: any = status.toString();
      return response;
    }
    return Promise.resolve<void>(<any>null);
  }
}

export interface IProductLineRequest {
  productLine?: string[] | undefined;
}

export interface IToolTypeRequest {
  toolType?: string[] | undefined;
}

export interface IStateRequest {
  state?: string[] | undefined;
  CountryCode?: any;
}

export interface IProjectNumberRequest {
  projectNumber?: string[] | undefined;
}

export interface ISupplierRequest {
  supplier?: string[] | undefined;
}

export interface ICountryRequest {
  country?: string[] | undefined;
}

export interface IItemRequest {
  partNumber?: string | undefined;
  partDescription?: string | undefined;
  engDrawingNumber?: string | undefined;
}

export interface IApproverManagers {
  id?: string | undefined;
  displayName?: string | undefined;
  mail?: string | undefined;
  userPrincipalName?: string | undefined;
}

export interface IApproval {
  RequestId?: string | undefined;
  EmailAddress?: string | undefined;
  Comments?: string | undefined;
  IsApproved?: string | undefined;
  LastUpdatedDateTime?: string | undefined;
  LastUpdatedUser?: string | undefined;
  SourceSystemId?: string | undefined;
}

export interface IDisposalRequestsFilters {
  lastModifiedDateMin?: string | undefined;
  lastModifiedDateMax?: string | undefined;
  completedDateMin?: string | undefined;
  completedDateMax?: string | undefined;
}
export interface IToolDisposalRequest {
  requestId?: string | undefined;
  requester?: string | undefined;
  businessUnit?: string | undefined;
  reasonForRequest?: string | undefined;
  toolNumber?: string | undefined;
  toolDescription?: string | undefined;
  supplierName?: string | undefined;
  supplierNumber?: string | undefined;
  toolTypeId?: string | undefined;
  poNumber?: string | undefined;
  totalPOValue?: string | undefined;
  productLines?: string | undefined;
  projectNumber?: string | undefined;
  modelYearMin?: string | undefined;
  modelYearMax?: string | undefined;
  lastUsedDate?: string | undefined;
  countryToolResidesIn?: string | undefined;
  stateToolResidesIn?: string | undefined;
  partDetails?: any | undefined;
  approverManagers?: object;
  approverManager?: [] | undefined;
  attachments?: any;
  notes?: string | undefined;
  reasonForDisposition?: string | undefined;
  estToolScrapValue?: string | undefined;
  willPolarisReceiveCredit?: string | undefined;
  partyResponsibleForDisposition?: string | undefined;
  explainationForScrapAggrement?: string | undefined;
  disposalStatusId?: string | undefined;
  disposalStatus?: string | undefined; //
  lastUpdatedDateTime?: string | undefined;
  lastUpdatedUser?: string | undefined;
  sourceSystemId?: string | undefined;
  completedDate?: string | undefined;
  assignedTo?: string | undefined;
}

export interface IAttachments {
  file?: any | undefined;
  tempRequestId?: string;
  originalRequestId?: string | undefined;
  fileName?: string | undefined;
  action?: string | undefined;
}
export interface IToolRequest {
  toolNumber?: string | undefined;
  projectNumber?: string | undefined;
  revision?: string | undefined;
  toolDescription?: string | undefined;
  action?: string | undefined;
  modificationTimeStamp?: string | undefined;
  site?: string | undefined;
  status?: string | undefined;
  toolType?: string | undefined;
  approvalRequestNumber?: string | undefined;
  toolUsage?: string | undefined;
  toolCategory?: string | undefined;
  requestorName?: string | undefined;
  productGroup?: string | undefined;
  toolOwnershipType?: string | undefined;
  estimatedNumberParts?: string | undefined;
  partsShipped?: string | undefined;
  material?: string | undefined;
  depreciation?: any | undefined;
  depreciationBeginDate?: string | undefined;
  toolValue?: any;
  toolLocation?: any;
  toolDimension?: string | undefined;
  tonnageRange?: string | undefined;
  numberOfSlides?: string | undefined;
  coolingType?: string | undefined;
  numberOfCavities?: string | undefined;
  ejectionSystem?: string | undefined;
  vacuum?: string | undefined;
  remainingShorts?: string | undefined;
  trimDie?: string | undefined;
  isAutomatic?: string | undefined;
  uniformCommercial?: string | undefined;
  manufacturingFeasibility?: string | undefined;
  toolOperation?: string | undefined;
  isSafetyInspected?: string | undefined;
  asset?: string | undefined;
  controls?: string | undefined;
  attachment?: string | undefined;
  component?: string | undefined;
  tcAssistStatus?: string | undefined;
  numberOfInserts?: any | undefined;
  volume?: string | undefined;
  movedDate?: any;
  toolMadeBy?: any;
  specificModelProduct?: string | undefined;
  toolMethod?: string | undefined;
  addVendorsQuoted?: string | undefined;
  programStatus?: string | undefined;
  toolBuiltLocation?: string | undefined;
  revisionReason?: string | undefined;
  taxRequired?: string | undefined;
  createDateTime?: string | undefined;
  createUser?: string | undefined;
  changeUser?: string | undefined;
  toolTypeId?: string | undefined;
  vendorNo?: string | undefined;
  vendorName?: string | undefined;
}

export class productLineRequest implements IProductLineRequest {
  productLine?: string[] | undefined;
  constructor(data?: IProductLineRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productLine = _data["productLine"];
    }
  }

  static fromJS(data: any): productLineRequest {
    data = typeof data === "object" ? data : {};
    let result = new productLineRequest();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data["productLine"] = this.productLine;
    return data;
  }

  clone(): productLineRequest {
    const json = this.toJSON();
    let result = new productLineRequest();
    result.init(json);
    return result;
  }
}

// new........
export class toolTypeRequest implements IToolTypeRequest {
  toolType?: string[] | undefined;
  constructor(data?: IToolTypeRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.toolType = _data["toolType"];
    }
  }

  static fromJS(data: any): toolTypeRequest {
    data = typeof data === "object" ? data : {};
    let result = new toolTypeRequest();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data["toolType"] = this.toolType;
    return data;
  }

  clone(): toolTypeRequest {
    const json = this.toJSON();
    let result = new toolTypeRequest();
    result.init(json);
    return result;
  }
}

export class stateRequest implements IStateRequest {
  state?: string[] | undefined;
  constructor(data?: IStateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.state = _data["state"];
    }
  }

  static fromJS(data: any): stateRequest {
    data = typeof data === "object" ? data : {};
    let result = new stateRequest();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data["state"] = this.state;

    return data;
  }

  clone(): stateRequest {
    const json = this.toJSON();
    let result = new stateRequest();
    result.init(json);
    return result;
  }
}

export class projectNumberRequest implements IProjectNumberRequest {
  projectNumber?: string[] | undefined;
  constructor(data?: IProjectNumberRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.projectNumber = _data["projectNumber"];
    }
  }

  static fromJS(data: any): projectNumberRequest {
    data = typeof data === "object" ? data : {};
    let result = new projectNumberRequest();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data["projectNumber"] = this.projectNumber;
    return data;
  }

  clone(): projectNumberRequest {
    const json = this.toJSON();
    let result = new projectNumberRequest();
    result.init(json);
    return result;
  }
}

export class supplierRequest implements ISupplierRequest {
  supplier?: string[] | undefined;
  constructor(data?: ISupplierRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.supplier = _data["supplier"];
    }
  }

  static fromJS(data: any): supplierRequest {
    data = typeof data === "object" ? data : {};
    let result = new supplierRequest();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data["supplier"] = this.supplier;
    return data;
  }

  clone(): supplierRequest {
    const json = this.toJSON();
    let result = new supplierRequest();
    result.init(json);
    return result;
  }
}

export interface ItoolDisposalFilterset {
  SortDirection?: any;
  SortColumn?: any;
  PageSize?: any | undefined;
  PageNumber?: any;
  AssignedTo?: any;
  CompletedDateMax?: any | undefined;
  CompletedDateMin?: any | undefined;
  LastModifiedDateMax?: any | undefined;
  LastModifiedDateMin?: any | undefined;
  RequestedBy?: any | undefined;
  SearchTerm?: any | undefined;
  DisposalStatusId?: any | undefined;
  RequestId?: any | undefined;
  CurrentUserEmail?: string | undefined;
}
export class ToolDisposalFilterset implements ItoolDisposalFilterset {
  SortDirection?: any;
  SortColumn?: any;
  PageSize?: any | undefined;
  PageNumber?: any;
  AssignedTo?: any;
  CompletedDateMax?: any | undefined;
  CompletedDateMin?: any | undefined;
  LastModifiedDateMax?: any | undefined;
  LastModifiedDateMin?: any | undefined;
  RequestedBy?: any | undefined;
  SearchTerm?: any | undefined;
  DisposalStatusId?: any | undefined;
  RequestId?: any | undefined;
  CurrentUserEmail?: string | undefined;

  constructor(data?: ItoolDisposalFilterset) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.AssignedTo = _data["AssignedTo"];
      this.PageNumber = _data["PageNumber"];
      this.PageSize = _data["PageSize"];
      this.CompletedDateMax = _data["CompletedDateMax"];
      this.SortColumn = _data["SortColumn"];
      this.SortDirection = _data["SortDirection"];
      this.CompletedDateMin = _data["CompletedDateMin"];
      this.LastModifiedDateMax = _data["LastModifiedDateMax"];
      this.LastModifiedDateMin = _data["LastModifiedDateMin"];
      this.RequestedBy = _data["RequestedBy"];
      this.SearchTerm = _data["SearchTerm"];
      this.DisposalStatusId = _data["DisposalStatusId"];
      this.RequestId = _data["RequestId"];
      this.CurrentUserEmail = _data["CurrentUserEmail"];
    }
  }

  static fromJS(data: any): ToolDisposalFilterset {
    data = typeof data === "object" ? data : {};
    let result = new ToolDisposalFilterset();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["PageNumber"] = this.PageNumber;
    data["PageSize"] = this.PageSize;
    data["SortColumn"] = this.SortColumn;
    data["SortDirection"] = this.SortDirection;
    data["AssignedTo"] = this.AssignedTo;
    data["CompletedDateMax"] = this.CompletedDateMax;
    data["CompletedDateMin"] = this.CompletedDateMin;
    data["LastModifiedDateMax"] = this.LastModifiedDateMax;
    data["LastModifiedDateMin"] = this.LastModifiedDateMin;
    data["RequestedBy"] = this.RequestedBy;
    data["SearchTerm"] = this.SearchTerm;
    data["DisposalStatusId"] = this.DisposalStatusId;
    data["RequestId"] = this.RequestId;
    data["CurrentUserEmail"] = this.CurrentUserEmail;

    return data;
  }

  clone(): ToolDisposalFilterset {
    const json = this.toJSON();
    let result = new ToolDisposalFilterset();
    result.init(json);
    return result;
  }
}

export class countryRequest implements ICountryRequest {
  country?: string[] | undefined;
  constructor(data?: ICountryRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.country = _data["country"];
    }
  }

  static fromJS(data: any): countryRequest {
    data = typeof data === "object" ? data : {};
    let result = new countryRequest();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data["country"] = this.country;
    return data;
  }

  clone(): countryRequest {
    const json = this.toJSON();
    let result = new countryRequest();
    result.init(json);
    return result;
  }
}

export class itemRequest implements IItemRequest {
  partNumber?: string | undefined;
  partDescription?: string | undefined;
  engDrawingNumber?: string | undefined;
  constructor(data?: IItemRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.partNumber = _data["partNumber"];
      this.partDescription = _data["partDescription"];
      this.engDrawingNumber = _data["engDrawingNumber"];
    }
  }

  static fromJS(data: any): itemRequest {
    data = typeof data === "object" ? data : {};
    let result = new itemRequest();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data["partNumber"] = this.partNumber;
    data["partDescription"] = this.partDescription;
    data["engDrawingNumber"] = this.engDrawingNumber;
    return data;
  }

  clone(): itemRequest {
    const json = this.toJSON();
    let result = new itemRequest();
    result.init(json);
    return result;
  }
}

export class approverManagers implements IApproverManagers {
  id?: string | undefined;
  displayName?: string | undefined;
  mail?: string | undefined;
  userPrincipalName?: string | undefined;
  constructor(data?: IApproverManagers) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
      this.mail = _data["mail"];
      this.userPrincipalName = _data["userPrincipalName"];
    }
  }

  static fromJS(data: any): approverManagers {
    data = typeof data === "object" ? data : {};
    let result = new approverManagers();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    data["mail"] = this.mail;
    data["userPrincipalName"] = this.userPrincipalName;
    return data;
  }

  clone(): approverManagers {
    const json = this.toJSON();
    let result = new approverManagers();
    result.init(json);
    return result;
  }
}

export class approval implements IApproval {
  RequestId?: string | undefined;
  EmailAddress?: string | undefined;
  Comments?: string | undefined;
  IsApproved?: string | undefined;
  LastUpdatedDateTime?: string | undefined;
  LastUpdatedUser?: string | undefined;
  SourceSystemId?: string | undefined;
  constructor(data?: IApproval) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.RequestId = _data["RequestId"];
      this.EmailAddress = _data["EmailAddress"];
      this.Comments = _data["Comments"];
      this.LastUpdatedDateTime = _data["LastUpdatedDateTime"];
      this.LastUpdatedUser = _data["LastUpdatedUser"];
      this.SourceSystemId = _data["SourceSystemId"];
      this.IsApproved = _data["IsApproved"];
    }
  }

  static fromJS(data: any): approval {
    data = typeof data === "object" ? data : {};
    let result = new approval();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["RequestId"] = this.RequestId;
    data["EmailAddress"] = this.EmailAddress;
    data["Comments"] = this.Comments;
    data["LastUpdatedDateTime"] = this.LastUpdatedDateTime;
    data["LastUpdatedUser"] = this.LastUpdatedUser;
    data["SourceSystemId"] = this.SourceSystemId;
    data["IsApproved"] = this.IsApproved;

    return data;
  }

  clone(): approval {
    const json = this.toJSON();
    let result = new approval();
    result.init(json);
    return result;
  }
}

export class attachments implements IAttachments {
  file?: any | undefined;
  tempRequestId?: string | undefined;
  originalRequestId?: string | undefined;
  fileName?: string | undefined;
  action?: string | undefined;
  constructor(data?: IAttachments) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.file = _data["file"];
      this.tempRequestId = _data["tempRequestId"];
      this.originalRequestId = _data["originalRequestId"];
      this.fileName = _data["fileName"];
      this.action = _data["action"];
    }
  }

  static fromJS(data: any): attachments {
    data = typeof data === "object" ? data : {};
    let result = new attachments();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["file"] = this.file;
    data["tempRequestId"] = this.tempRequestId;
    data["originalRequestId"] = this.originalRequestId;
    data["fileName"] = this.fileName;
    data["action"] = this.action;
    return data;
  }

  clone(): attachments {
    const json = this.toJSON();
    let result = new attachments();
    result.init(json);
    return result;
  }
}

export class disposalRequestsFilters implements IDisposalRequestsFilters {
  lastModifiedDateMin?: string | undefined;
  lastModifiedDateMax?: string | undefined;
  completedDateMin?: string | undefined;
  completedDateMax?: string | undefined;
  constructor(data?: IDisposalRequestsFilters) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lastModifiedDateMin = _data["lastModifiedDateMin"];
      this.lastModifiedDateMax = _data["lastModifiedDateMax"];
      this.completedDateMin = _data["completedDateMin"];
      this.completedDateMax = _data["completedDateMax"];
    }
  }

  static fromJS(data: any): disposalRequestsFilters {
    data = typeof data === "object" ? data : {};
    let result = new disposalRequestsFilters();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["lastModifiedDateMin"] = this.lastModifiedDateMin;
    data["lastModifiedDateMax"] = this.lastModifiedDateMax;
    data["completedDateMin"] = this.completedDateMin;
    data["completedDateMax"] = this.completedDateMax;
    return data;
  }

  clone(): disposalRequestsFilters {
    const json = this.toJSON();
    let result = new disposalRequestsFilters();
    result.init(json);
    return result;
  }
}

export class disposalRequest implements IToolDisposalRequest {
  requestId?: string | undefined;
  requester?: string | undefined;
  businessUnit?: string | undefined;
  reasonForRequest?: string | undefined;
  toolNumber?: string | undefined;
  toolDescription?: string | undefined;
  supplierName?: string | undefined;
  supplierNumber?: string | undefined;
  toolTypeId?: string | undefined;
  poNumber?: string | undefined;
  totalPOValue?: string | undefined;
  productLines?: string | undefined;
  projectNumber?: string | undefined;
  modelYearMin?: string | undefined;
  modelYearMax?: string | undefined;
  lastUsedDate?: string | undefined;
  countryToolResidesIn?: string | undefined;
  stateToolResidesIn?: string | undefined;
  partDetails?: any | undefined;
  approverManagers?: object;
  attachments?: string | undefined;
  notes?: string | undefined;
  reasonForDisposition?: string | undefined;
  estToolScrapValue?: string | undefined;
  willPolarisReceiveCredit?: string | undefined;
  partyResponsibleForDisposition?: string | undefined;
  explainationForScrapAggrement?: string | undefined;
  disposalStatusId?: string | undefined;
  disposalStatus?: string | undefined;
  lastUpdatedDateTime?: string | undefined;
  lastUpdatedUser?: string | undefined;
  sourceSystemId?: string | undefined;
  completedDate?: string | undefined;
  assignedTo?: string | undefined;
  constructor(data?: IToolDisposalRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.disposalStatus = _data["disposalStatus"];
      this.requestId = _data["requestId"];
      this.requester = _data["requester"];
      this.businessUnit = _data["businessUnit"];
      this.reasonForRequest = _data["reasonForRequest"];
      this.toolNumber = _data["toolNumber"];
      this.toolDescription = _data["toolDescription"];
      this.supplierName = _data["supplierName"];
      this.supplierNumber = _data["supplierNumber"];
      this.poNumber = _data["poNumber"];
      this.totalPOValue = _data["totalPOValue"];
      this.productLines = _data["productLines"];
      this.projectNumber = _data["projectNumber"];
      this.modelYearMin = _data["modelYearMin"];
      this.modelYearMax = _data["modelYearMax"];
      this.lastUsedDate = _data["lastUsedDate"];
      this.countryToolResidesIn = _data["countryToolResidesIn"];
      this.stateToolResidesIn = _data["stateToolResidesIn"];
      this.partDetails = _data["partDetails"];
      this.approverManagers = _data["approverManagers"];
      this.attachments = _data["attachments"];
      this.notes = _data["notes"];
      this.reasonForDisposition = _data["reasonForDisposition"];
      this.estToolScrapValue = _data["estToolScrapValue"];
      this.willPolarisReceiveCredit = _data["willPolarisReceiveCredit"];
      this.partyResponsibleForDisposition =
        _data["partyResponsibleForDisposition"];
      this.explainationForScrapAggrement =
        _data["explainationForScrapAggrement"];
      this.assignedTo = _data["assignedTo"];
      this.disposalStatusId = _data["disposalStatusId"];
      this.lastUpdatedDateTime = _data["lastUpdatedDateTime"];
      this.lastUpdatedUser = _data["lastUpdatedUser"];
      this.sourceSystemId = _data["sourceSystemId"];
      this.completedDate = _data["completedDate"];
    }
  }

  static fromJS(data: any): disposalRequest {
    data = typeof data === "object" ? data : {};
    let result = new disposalRequest();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data["disposalStatus"] = this.disposalStatus;
    data["requestId"] = this.requestId;
    data["requester"] = this.requester;
    data["businessUnit"] = this.businessUnit;
    data["reasonForRequest"] = this.reasonForRequest;
    data["toolNumber"] = this.toolNumber;
    data["toolDescription"] = this.toolDescription;
    data["supplierName"] = this.supplierName;
    data["supplierNumber"] = this.supplierNumber;
    data["toolTypeId"] = this.toolTypeId;
    data["poNumber"] = this.poNumber;
    data["totalPOValue"] = this.totalPOValue;
    data["productLines"] = this.productLines;
    data["projectNumber"] = this.projectNumber;
    data["modelYearMin"] = this.modelYearMin;
    data["modelYearMax"] = this.modelYearMax;
    data["lastUsedDate"] = this.lastUsedDate;
    data["countryToolResidesIn"] = this.countryToolResidesIn;
    data["stateToolResidesIn"] = this.stateToolResidesIn;
    data["partDetails"] = this.partDetails;
    data["approverManagers"] = this.approverManagers;
    data["attachments"] = this.attachments;
    data["notes"] = this.notes;
    data["reasonForDisposition"] = this.reasonForDisposition;
    data["estToolScrapValue"] = this.estToolScrapValue;
    data["willPolarisReceiveCredit"] = this.willPolarisReceiveCredit;
    data["partyResponsibleForDisposition"] =
      this.partyResponsibleForDisposition;
    data["explainationForScrapAggrement"] = this.explainationForScrapAggrement;
    data["assignedTo"] = this.assignedTo;
    data["disposalStatusId"] = this.disposalStatusId;
    data["lastUpdatedDateTime"] = this.lastUpdatedDateTime;
    data["lastUpdatedUser"] = this.lastUpdatedUser;
    data["sourceSystemId"] = this.sourceSystemId;
    data["completedDate"] = this.completedDate;
    return data;
  }

  clone(): disposalRequest {
    const json = this.toJSON();
    let result = new disposalRequest();
    result.init(json);
    return result;
  }
}

export class toolDisposalRequest implements IToolDisposalRequest {
  requestId?: string | undefined;
  requester?: string | undefined;
  businessUnit?: string | undefined;
  reasonForRequest?: string | undefined;
  toolNumber?: string | undefined;
  toolDescription?: string | undefined;
  supplierName?: string | undefined;
  supplierNumber?: string | undefined;
  toolTypeId?: string | undefined;
  poNumber?: string | undefined;
  totalPOValue?: string | undefined;
  productLines?: string | undefined;
  projectNumber?: string | undefined;
  modelYearMin?: string | undefined;
  modelYearMax?: string | undefined;
  lastUsedDate?: string | undefined;
  countryToolResidesIn?: string | undefined;
  stateToolResidesIn?: string | undefined;
  partDetails?: any | undefined;
  approverManagers?: object;
  attachments?: string | undefined;
  notes?: string | undefined;
  reasonForDisposition?: string | undefined;
  estToolScrapValue?: string | undefined;
  willPolarisReceiveCredit?: string | undefined;
  partyResponsibleForDisposition?: string | undefined;
  explainationForScrapAggrement?: string | undefined;
  disposalStatusId?: string | undefined;
  lastUpdatedDateTime?: string | undefined;
  lastUpdatedUser?: string | undefined;
  sourceSystemId?: string | undefined;
  completedDate?: string | undefined;
  assignedTo?: string | undefined;
  constructor(data?: IToolDisposalRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.requestId = _data["requestId"];
      this.requester = _data["requester"];
      this.businessUnit = _data["businessUnit"];
      this.reasonForRequest = _data["reasonForRequest"];
      this.toolNumber = _data["toolNumber"];
      this.toolDescription = _data["toolDescription"];
      this.supplierName = _data["supplierName"];
      this.supplierNumber = _data["supplierNumber"];
      this.poNumber = _data["poNumber"];
      this.totalPOValue = _data["totalPOValue"];
      this.productLines = _data["productLines"];
      this.projectNumber = _data["projectNumber"];
      this.modelYearMin = _data["modelYearMin"];
      this.modelYearMax = _data["modelYearMax"];
      this.lastUsedDate = _data["lastUsedDate"];
      this.countryToolResidesIn = _data["countryToolResidesIn"];
      this.stateToolResidesIn = _data["stateToolResidesIn"];
      this.partDetails = _data["partDetails"];
      this.approverManagers = _data["approverManagers"];
      this.attachments = _data["attachments"];
      this.notes = _data["notes"];
      this.reasonForDisposition = _data["reasonForDisposition"];
      this.estToolScrapValue = _data["estToolScrapValue"];
      this.willPolarisReceiveCredit = _data["willPolarisReceiveCredit"];
      this.partyResponsibleForDisposition =
        _data["partyResponsibleForDisposition"];
      this.explainationForScrapAggrement =
        _data["explainationForScrapAggrement"];
      this.assignedTo = _data["assignedTo"];
      this.disposalStatusId = _data["disposalStatusId"];
      this.lastUpdatedDateTime = _data["lastUpdatedDateTime"];
      this.lastUpdatedUser = _data["lastUpdatedUser"];
      this.sourceSystemId = _data["sourceSystemId"];
      this.completedDate = _data["completedDate"];
    }
  }

  static fromJS(data: any): toolDisposalRequest {
    data = typeof data === "object" ? data : {};
    let result = new toolDisposalRequest();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data["requestId"] = this.requestId;
    data["requester"] = this.requester;
    data["businessUnit"] = this.businessUnit;
    data["reasonForRequest"] = this.reasonForRequest;
    data["toolNumber"] = this.toolNumber;
    data["toolDescription"] = this.toolDescription;
    data["supplierName"] = this.supplierName;
    data["supplierNumber"] = this.supplierNumber;
    data["toolTypeId"] = this.toolTypeId;
    data["poNumber"] = this.poNumber;
    data["totalPOValue"] = this.totalPOValue;
    data["productLines"] = this.productLines;
    data["projectNumber"] = this.projectNumber;
    data["modelYearMin"] = this.modelYearMin;
    data["modelYearMax"] = this.modelYearMax;
    data["lastUsedDate"] = this.lastUsedDate;
    data["countryToolResidesIn"] = this.countryToolResidesIn;
    data["stateToolResidesIn"] = this.stateToolResidesIn;
    data["partDetails"] = this.partDetails;
    data["approverManagers"] = this.approverManagers;
    data["attachments"] = this.attachments;
    data["notes"] = this.notes;
    data["reasonForDisposition"] = this.reasonForDisposition;
    data["estToolScrapValue"] = this.estToolScrapValue;
    data["willPolarisReceiveCredit"] = this.willPolarisReceiveCredit;
    data["partyResponsibleForDisposition"] =
      this.partyResponsibleForDisposition;
    data["explainationForScrapAggrement"] = this.explainationForScrapAggrement;
    data["assignedTo"] = this.assignedTo;
    data["disposalStatusId"] = this.disposalStatusId;
    data["lastUpdatedDateTime"] = this.lastUpdatedDateTime;
    data["lastUpdatedUser"] = this.lastUpdatedUser;
    data["sourceSystemId"] = this.sourceSystemId;
    data["completedDate"] = this.completedDate;
    return data;
  }

  clone(): toolDisposalRequest {
    const json = this.toJSON();
    let result = new toolDisposalRequest();
    result.init(json);
    return result;
  }
}

export class toolRequest implements IToolRequest {
  toolNumber?: string | undefined;
  projectNumber?: string | undefined;
  revision?: string | undefined;
  toolDescription?: string | undefined;
  action?: string | undefined;
  modificationTimeStamp?: string | undefined;
  site?: string | undefined;
  status?: string | undefined;
  toolType?: string | undefined;
  approvalRequestNumber?: string | undefined;
  toolUsage?: string | undefined;
  toolCategory?: string | undefined;
  requestorName?: string | undefined;
  productGroup?: string | undefined;
  toolOwnershipType?: string | undefined;
  estimatedNumberParts?: string | undefined;
  partsShipped?: string | undefined;
  material?: string | undefined;
  depreciation?: any | undefined;
  depreciationBeginDate?: string | undefined;
  toolValue?: any;
  toolLocation?: any;
  toolDimension?: string | undefined;
  tonnageRange?: string | undefined;
  numberOfSlides?: string | undefined;
  coolingType?: string | undefined;
  numberOfCavities?: string | undefined;
  ejectionSystem?: string | undefined;
  vacuum?: string | undefined;
  remainingShorts?: string | undefined;
  trimDie?: string | undefined;
  isAutomatic?: string | undefined;
  uniformCommercial?: string | undefined;
  manufacturingFeasibility?: string | undefined;
  toolOperation?: string | undefined;
  isSafetyInspected?: string | undefined;
  asset?: string | undefined;
  controls?: string | undefined;
  attachment?: string | undefined;
  component?: string | undefined;
  tcAssistStatus?: string | undefined;
  numberOfInserts?: any | undefined;
  volume?: string | undefined;
  movedDate?: any;
  toolMadeBy?: any;
  specificModelProduct?: string | undefined;
  toolMethod?: string | undefined;
  addVendorsQuoted?: string | undefined;
  programStatus?: string | undefined;
  toolBuiltLocation?: string | undefined;
  revisionReason?: string | undefined;
  taxRequired?: string | undefined;
  createDateTime?: string | undefined;
  createUser?: string | undefined;
  changeUser?: string | undefined;
  toolTypeId?: string | undefined;
  vendorNo?: string | undefined;
  vendorName?: string | undefined;
  constructor(data?: IToolRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.toolNumber = _data["toolNumber"];
      this.projectNumber = _data["projectNumber"];
      this.revision = _data["revision"];
      this.toolDescription = _data["toolDescription"];
      this.toolNumber = _data["toolNumber"];
      this.toolDescription = _data["toolDescription"];
      this.action = _data["action"];
      this.modificationTimeStamp = _data["modificationTimeStamp"];
      this.site = _data["site"];
      this.status = _data["status"];
      this.toolType = _data["toolType"];
      this.approvalRequestNumber = _data["approvalRequestNumber"];
      this.toolUsage = _data["toolUsage"];
      this.toolCategory = _data["toolCategory"];
      this.requestorName = _data["requestorName"];
      this.productGroup = _data["productGroup"];
      this.toolOwnershipType = _data["toolOwnershipType"];
      this.estimatedNumberParts = _data["estimatedNumberParts"];
      this.partsShipped = _data["partsShipped"];
      this.material = _data["material"];
      this.depreciation = _data["depreciation"];
      this.depreciationBeginDate = _data["depreciationBeginDate"];
      this.toolValue = _data["toolValue"];
      this.toolLocation = _data["toolLocation"];
      this.toolDimension = _data["toolDimension"];
      this.tonnageRange = _data["tonnageRange"];
      this.numberOfSlides = _data["numberOfSlides"];
      this.coolingType = _data["coolingType"];
      this.numberOfCavities = _data["numberOfCavities"];
      this.ejectionSystem = _data["ejectionSystem"];
      this.vacuum = _data["vacuum"];
      this.remainingShorts = _data["remainingShorts"];
      this.trimDie = _data["trimDie"];
      this.isAutomatic = _data["isAutomatic"];
      this.uniformCommercial = _data["uniformCommercial"];
      this.manufacturingFeasibility = _data["manufacturingFeasibility"];
      this.toolOperation = _data["toolOperation"];
      this.isSafetyInspected = _data["isSafetyInspected"];
      this.asset = _data["asset"];
      this.controls = _data["controls"];
      this.attachment = _data["attachment"];
      this.component = _data["component"];
      this.tcAssistStatus = _data["tcAssistStatus"];
      this.numberOfInserts = _data["numberOfInserts"];
      this.volume = _data["volume"];
      this.movedDate = _data["movedDate"];
      this.toolMadeBy = _data["toolMadeBy"];
      this.specificModelProduct = _data["specificModelProduct"];
      this.toolMethod = _data["toolMethod"];
      this.addVendorsQuoted = _data["addVendorsQuoted"];
      this.programStatus = _data["programStatus"];
      this.toolBuiltLocation = _data["toolBuiltLocation"];
      this.revisionReason = _data["revisionReason"];
      this.taxRequired = _data["taxRequired"];
      this.createDateTime = _data["createDateTime"];

      this.createUser = _data["createUser"];
      this.changeUser = _data["changeUser"];
      this.toolTypeId = _data["toolTypeId"];
      this.vendorNo = _data["vendorNo"];
      this.vendorName = _data["vendorName"];
    }
  }

  static fromJS(data: any): toolRequest {
    data = typeof data === "object" ? data : {};
    let result = new toolRequest();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data["toolNumber"] = this.toolNumber;
    data["projectNumber"] = this.projectNumber;
    data["revision"] = this.revision;
    data["toolDescription"] = this.toolDescription;
    data["action"] = this.action;
    data["modificationTimeStamp"] = this.modificationTimeStamp;
    data["site"] = this.site;
    data["status"] = this.status;
    data["toolType"] = this.toolType;
    data["approvalRequestNumber"] = this.approvalRequestNumber;
    data["toolUsage"] = this.toolUsage;
    data["toolCategory"] = this.toolCategory;
    data["requestorName"] = this.requestorName;
    data["productGroup"] = this.productGroup;
    data["toolOwnershipType"] = this.toolOwnershipType;
    data["estimatedNumberParts"] = this.estimatedNumberParts;
    data["partsShipped"] = this.partsShipped;
    data["material"] = this.material;
    data["depreciation"] = this.depreciation;
    data["depreciationBeginDate"] = this.depreciationBeginDate;
    data["toolValue"] = this.toolValue;
    data["toolLocation"] = this.toolLocation;
    data["toolDimension"] = this.toolDimension;
    data["tonnageRange"] = this.tonnageRange;
    data["numberOfSlides"] = this.numberOfSlides;
    data["coolingType"] = this.coolingType;
    data["numberOfCavities"] = this.numberOfCavities;
    data["ejectionSystem"] = this.ejectionSystem;
    data["vacuum"] = this.vacuum;
    data["remainingShorts"] = this.remainingShorts;
    data["trimDie"] = this.trimDie;
    data["isAutomatic"] = this.isAutomatic;
    data["uniformCommercial"] = this.uniformCommercial;
    data["manufacturingFeasibility"] = this.manufacturingFeasibility;
    data["toolOperation"] = this.toolOperation;
    data["isSafetyInspected"] = this.isSafetyInspected;
    data["asset"] = this.asset;
    data["controls"] = this.controls;
    data["attachment"] = this.attachment;
    data["component"] = this.component;
    data["tcAssistStatus"] = this.tcAssistStatus;
    data["numberOfInserts"] = this.numberOfInserts;
    data["volume"] = this.volume;
    data["movedDate"] = this.movedDate;
    data["toolMadeBy"] = this.toolMadeBy;
    data["specificModelProduct"] = this.specificModelProduct;
    data["toolMethod"] = this.toolMethod;
    data["addVendorsQuoted"] = this.addVendorsQuoted;
    data["programStatus"] = this.programStatus;
    data["toolBuiltLocation"] = this.toolBuiltLocation;
    data["revisionReason"] = this.revisionReason;
    data["taxRequired"] = this.taxRequired;
    data["createDateTime"] = this.createDateTime;
    data["createUser"] = this.createUser;
    data["changeUser"] = this.changeUser;
    data["toolTypeId"] = this.createDateTime;
    data["vendorNo"] = this.createUser;
    data["vendorName"] = this.changeUser;
    return data;
  }

  clone(): toolRequest {
    const json = this.toJSON();
    let result = new toolRequest();
    result.init(json);
    return result;
  }
}

export interface IProductLineResponse {
  productLine?: productLineRequest[] | undefined;
}

export interface IToolTypeResponse {
  toolType?: toolTypeRequest[] | undefined;
}

export interface IStateResponse {
  state?: stateRequest[] | undefined;
}

export interface IProjectNumberResponse {
  projectNumber?: projectNumberRequest[] | undefined;
}

export interface ISupplierResponse {
  supplier?: supplierRequest[] | undefined;
}

export interface ICountryResponse {
  country?: countryRequest[] | undefined;
}

export interface IItemResponse {
  item?: itemRequest[] | undefined;
}

export interface IToolDisposalResponse {
  disposalRequest?: toolDisposalRequest[] | undefined;
}

export interface IToolDisposalResponse1 {
  disposalRequest?: disposalRequest[] | undefined;
}

export interface IApproverManagersResponse {
  data?: approverManagers[] | undefined;
}

export interface IToolResponse {
  tool?: toolRequest[] | undefined;
}

export class productLineResponse implements IProductLineResponse {
  productLine?: productLineRequest[];

  constructor(data?: IProductLineResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["productLine"])) {
        this.productLine = [] as any;
        for (let item of _data["productLine"])
          this.productLine!.push(productLineRequest.fromJS(item));
      }

      this.productLine = _data["productLine"];
    }
  }

  static fromJS(productLine: any): productLineResponse {
    productLine = typeof productLine === "object" ? productLine : {};
    let result = new productLineResponse();
    result.init(productLine);
    return result;
  }

  toJSON(productLine?: any) {
    productLine = typeof productLine === "object" ? productLine : {};
    if (Array.isArray(this.productLine)) {
      productLine["productLine"] = [];
      for (let item of this.productLine)
        productLine["productLine"].push(item.toJSON());
    }

    return productLine;
  }

  clone(): productLineResponse {
    const json = this.toJSON();
    let result = new productLineResponse();
    result.init(json);
    return result;
  }
}

export class toolTypeResponse implements IToolTypeResponse {
  toolType?: toolTypeRequest[];

  constructor(data?: IToolTypeResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["toolType"])) {
        this.toolType = [] as any;
        for (let item of _data["toolType"])
          this.toolType!.push(toolTypeRequest.fromJS(item));
      }

      this.toolType = _data["toolType"];
    }
  }

  static fromJS(toolType: any): toolTypeResponse {
    toolType = typeof toolType === "object" ? toolType : {};
    let result = new toolTypeResponse();
    result.init(toolType);
    return result;
  }

  toJSON(toolType?: any) {
    toolType = typeof toolType === "object" ? toolType : {};
    if (Array.isArray(this.toolType)) {
      toolType["toolType"] = [];
      for (let item of this.toolType) toolType["toolType"].push(item.toJSON());
    }

    return toolType;
  }

  clone(): toolTypeResponse {
    const json = this.toJSON();
    let result = new toolTypeResponse();
    result.init(json);
    return result;
  }
}

export class stateResponse implements IStateResponse {
  state?: stateRequest[];
  constructor(data?: IStateResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["state"])) {
        this.state = [] as any;
        for (let item of _data["state"])
          this.state!.push(stateRequest.fromJS(item));
      }

      this.state = _data["state"];
    }
  }

  static fromJS(state: any): stateResponse {
    state = typeof state === "object" ? state : {};
    let result = new stateResponse();
    result.init(state);
    return result;
  }

  toJSON(state?: any) {
    state = typeof state === "object" ? state : {};
    if (Array.isArray(this.state)) {
      state["state"] = [];
      for (let item of this.state) state["state"].push(item.toJSON());
    }

    return state;
  }

  clone(): stateResponse {
    const json = this.toJSON();
    let result = new stateResponse();
    result.init(json);
    return result;
  }
}

export class projectNumberResponse implements IProjectNumberResponse {
  projectNumber?: projectNumberRequest[];

  constructor(data?: IProjectNumberResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["projectNumber"])) {
        this.projectNumber = [] as any;
        for (let item of _data["projectNumber"])
          this.projectNumber!.push(projectNumberRequest.fromJS(item));
      }

      this.projectNumber = _data["projectNumber"];
    }
  }

  static fromJS(projectNumber: any): projectNumberResponse {
    projectNumber = typeof projectNumber === "object" ? projectNumber : {};
    let result = new projectNumberResponse();
    result.init(projectNumber);
    return result;
  }

  toJSON(projectNumber?: any) {
    projectNumber = typeof projectNumber === "object" ? projectNumber : {};
    if (Array.isArray(this.projectNumber)) {
      projectNumber["projectNumber"] = [];
      for (let item of this.projectNumber)
        projectNumber["projectNumber"].push(item.toJSON());
    }

    return projectNumber;
  }

  clone(): projectNumberResponse {
    const json = this.toJSON();
    let result = new projectNumberResponse();
    result.init(json);
    return result;
  }
}

export class supplierResponse implements ISupplierResponse {
  supplier?: supplierRequest[];

  constructor(data?: ISupplierResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["supplier"])) {
        this.supplier = [] as any;
        for (let item of _data["supplier"])
          this.supplier!.push(supplierRequest.fromJS(item));
      }

      this.supplier = _data["supplier"];
    }
  }

  static fromJS(supplier: any): supplierResponse {
    supplier = typeof supplier === "object" ? supplier : {};
    let result = new supplierResponse();
    result.init(supplier);
    return result;
  }

  toJSON(supplier?: any) {
    supplier = typeof supplier === "object" ? supplier : {};
    if (Array.isArray(this.supplier)) {
      supplier["supplier"] = [];
      for (let item of this.supplier) supplier["supplier"].push(item.toJSON());
    }

    return supplier;
  }

  clone(): supplierResponse {
    const json = this.toJSON();
    let result = new supplierResponse();
    result.init(json);
    return result;
  }
}

export class countryResponse implements ICountryResponse {
  country?: countryRequest[];

  constructor(data?: ICountryResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["country"])) {
        this.country = [] as any;
        for (let item of _data["country"])
          this.country!.push(countryRequest.fromJS(item));
      }

      this.country = _data["country"];
    }
  }

  static fromJS(country: any): countryResponse {
    country = typeof country === "object" ? country : {};
    let result = new countryResponse();
    result.init(country);
    return result;
  }

  toJSON(country?: any) {
    country = typeof country === "object" ? country : {};
    if (Array.isArray(this.country)) {
      country["country"] = [];
      for (let item of this.country) country["country"].push(item.toJSON());
    }

    return country;
  }

  clone(): countryResponse {
    const json = this.toJSON();
    let result = new countryResponse();
    result.init(json);
    return result;
  }
}

export class itemResponse implements IItemResponse {
  item?: itemRequest[];

  constructor(data?: IItemResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["item"])) {
        this.item = [] as any;
        for (let item of _data["item"])
          this.item!.push(itemRequest.fromJS(item));
      }

      this.item = _data["item"];
    }
  }

  static fromJS(item: any): itemResponse {
    item = typeof item === "object" ? item : {};
    let result = new itemResponse();
    result.init(item);
    return result;
  }

  toJSON(item?: any) {
    item = typeof item === "object" ? item : {};
    if (Array.isArray(this.item)) {
      item["item"] = [];
      for (let item of this.item) item["item"].push(item.toJSON());
    }

    return item;
  }

  clone(): itemResponse {
    const json = this.toJSON();
    let result = new itemResponse();
    result.init(json);
    return result;
  }
}

export class approverManagersResponse implements IApproverManagersResponse {
  data?: approverManagers[];
  constructor(data?: IApproverManagersResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["item"])) {
        this.data = [] as any;
        for (let item of _data["item"])
          this.data!.push(approverManagers.fromJS(item));
      }

      this.data = _data["data"];
    }
  }

  static fromJS(item: any): approverManagersResponse {
    item = typeof item === "object" ? item : {};
    let result = new approverManagersResponse();
    result.init(item);
    return result;
  }

  toJSON(item?: any) {
    item = typeof item === "object" ? item : {};
    if (Array.isArray(this.data)) {
      item["data"] = [];
      for (let item of this.data) item["data"].push(item.toJSON());
    }

    return item;
  }

  clone(): approverManagersResponse {
    const json = this.toJSON();
    let result = new approverManagersResponse();
    result.init(json);
    return result;
  }
}

export class disposalResponse implements IToolDisposalResponse1 {
  disposalRequest?: disposalRequest[];

  constructor(data?: IToolDisposalResponse1) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["disposalRequest"])) {
        this.disposalRequest = [] as any;
        for (let item of _data["disposalRequest"])
          this.disposalRequest!.push(disposalResponse.fromJS(item));
      }
      this.disposalRequest = _data["disposalRequest"];
    }
  }

  static fromJS(disposalRequest: any): disposalResponse {
    disposalRequest =
      typeof disposalRequest === "object" ? disposalRequest : {};
    let result = new disposalResponse();
    result.init(disposalRequest);
    return result;
  }

  toJSON(disposalRequest?: any) {
    disposalRequest =
      typeof disposalRequest === "object" ? disposalRequest : {};
    if (Array.isArray(this.disposalRequest)) {
      disposalRequest["disposalRequest"] = [];
      for (let item of this.disposalRequest)
        disposalRequest["disposalRequest"].push(item.toJSON());
    }

    return disposalRequest;
  }

  clone(): disposalResponse {
    const json = this.toJSON();
    let result = new disposalResponse();
    result.init(json);
    return result;
  }
}

export class tooldisposalResponse implements IToolDisposalResponse {
  disposalRequest?: toolDisposalRequest[];

  constructor(data?: IToolDisposalResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["disposalRequest"])) {
        this.disposalRequest = [] as any;
        for (let item of _data["disposalRequest"])
          this.disposalRequest!.push(toolDisposalRequest.fromJS(item));
      }
      this.disposalRequest = _data["disposalRequest"];
    }
  }

  static fromJS(disposalRequest: any): tooldisposalResponse {
    disposalRequest =
      typeof disposalRequest === "object" ? disposalRequest : {};
    let result = new tooldisposalResponse();
    result.init(disposalRequest);
    return result;
  }

  toJSON(disposalRequest?: any) {
    disposalRequest =
      typeof disposalRequest === "object" ? disposalRequest : {};
    if (Array.isArray(this.disposalRequest)) {
      disposalRequest["disposalRequest"] = [];
      for (let item of this.disposalRequest)
        disposalRequest["disposalRequest"].push(item.toJSON());
    }

    return disposalRequest;
  }

  clone(): tooldisposalResponse {
    const json = this.toJSON();
    let result = new tooldisposalResponse();
    result.init(json);
    return result;
  }
}

export class toolResponse implements IToolResponse {
  tool?: toolRequest[];

  constructor(data?: IToolResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["tool"])) {
        this.tool = [] as any;
        for (let item of _data["tool"])
          this.tool!.push(toolRequest.fromJS(item));
      }
      this.tool = _data["tool"];
    }
  }

  static fromJS(tool: any): toolResponse {
    tool = typeof tool === "object" ? tool : {};
    let result = new toolResponse();
    result.init(tool);
    return result;
  }

  toJSON(tool?: any) {
    tool = typeof tool === "object" ? tool : {};
    if (Array.isArray(this.tool)) {
      tool["tool"] = [];
      for (let item of this.tool) tool["tool"].push(item.toJSON());
    }

    return tool;
  }

  clone(): toolResponse {
    const json = this.toJSON();
    let result = new toolResponse();
    result.init(json);
    return result;
  }
}

export enum ListSortDirection {
  Ascending = "Ascending",
  Descending = "Descending",
}

export enum ToolDisposalSortOption {
  requestId = "requestId",
  lastModifiedDate = "lastModifiedDate",
  toolNumber = "toolNumber",
  Undefined = "",
}

function throwException(
  arg0: string,
  status: number,
  _responseText: string,
  result401: any
): any {
  throw new Error("Function not implemented.");
}
